import type { ApiResponse } from 'vopay';

// Every Users api call rejects on failure (including `Success: false`), so call sites only have to
// catch. Logs once here rather than at every call site.
export default async function unwrap<T extends ApiResponse>(request: Promise<T>): Promise<T> {
  try {
    const res = await request;

    if (!res.Success) throw new Error(res.ErrorMessage);

    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
